export default __webpack_public_path__ + "static/13_9-dec0cb1a037fbb98746d3d06dc9b44ff.png";